import React from 'react';
import { Link } from 'react-router-dom';

const footerLinks = {
  layanan: [
    { label: 'Internet Broadband', to: '/internet/broadband' },
    { label: 'Internet Dedicated', to: '/internet/dedicated' },
    { label: 'Metro-E', to: '/internet/metro-e' },
    { label: 'Internet Satelit Starlink', to: '/produk-lainnya/starlink' },
    { label: 'VPN Security', to: '/produk-lainnya/vpn' },
    { label: 'Traffic Management', to: '/produk-lainnya/traffic-management' },
  ],
  infrastruktur: [
    { label: 'Fiber Optic (FTTH)', to: '/layanan-it/fiber_optic' },
    { label: 'IP Camera & CCTV', to: '/cctv' },
    { label: 'IP Phone PBX', to: '/layanan-it/ip-phone' },
    { label: 'Tower Triangle', to: '/layanan-it/tower-triangle' },
    { label: 'Data Center Tier III', to: '/layanan/data-center' },
    { label: 'Cloud Services', to: '/layanan/cloud-services' },
  ],
  itSolutions: [
    { label: 'Custom Software', to: '/layanan-it/custom_sofware' },
    { label: 'ERP & CRM System', to: '/layanan/erp-crm' },
    { label: 'SIMRS & HRIS', to: '/layanan/simrs-hris' },
    { label: 'IT Support 24/7', to: '/layanan-it/it_support' },
    { label: 'Network Monitoring', to: '/layanan/network-monitoring' },
    { label: 'Microsoft Licensing', to: '/layanan/microsoft-licensing' },
  ],
  legal: [
    { label: 'Kebijakan Privasi', to: '/kebijakan-privasi' },
    { label: 'Ketentuan Layanan', to: '/ketentuan-layanan' },
    { label: 'Alur Transaksi', to: '/alur-transaksi' },
    { label: 'FAQ', to: '/faq' },
    { label: 'Tentang Kami', to: '/tentang' },
    { label: 'Gallery', to: '/gallery' },
  ],
};

const ScrollToTopLink = ({ to, children }) => (
  <Link
    to={to}
    className="hover:text-white transition-colors duration-200 hover:translate-x-1 inline-block text-sm"
  >
    {children}
  </Link>
);

const FooterColumn = ({ title, links }) => (
  <div>
    <h4 className="text-sm font-semibold mb-4 text-white">{title}</h4>
    <ul className="space-y-2 text-gray-400">
      {links.map((link) => (
        <li key={link.label}>
          <ScrollToTopLink to={link.to}>{link.label}</ScrollToTopLink>
        </li>
      ))}
    </ul>
  </div>
);

const Footer = () => {
  const scrollToTop = () => window.scrollTo({ top: 0, behavior: 'smooth' });

  return (
    <footer className="text-white py-14" style={{ background: 'linear-gradient(135deg, #111827 0%, #1f2937 100%)' }}>
      <div className="section-container">
        <div className="grid md:grid-cols-2 lg:grid-cols-6 gap-8">
          {/* Company Info */}
          <div className="lg:col-span-2">
            <h3 className="text-xl font-bold mb-3">Telnet Indonesia</h3>
            <p className="text-gray-400 text-sm mb-1">PT Telekomunikasi Internet Indonesia</p>
            <p className="text-gray-400 text-sm mb-5">Internet Service Provider</p>
            <div className="space-y-2 text-xs text-gray-400">
              <p>Jl. Dr. Mr. Mohd. Hasan No. 33, Banda Aceh, 23245</p>
              <p>08777 888 2022</p>
              <p>info@telnet.co.id</p>
            </div>
            {/* Social Media */}
            <div className="flex items-center gap-3 mt-5">
              <a href="https://wa.me/628777882022" target="_blank" rel="noopener noreferrer" className="w-8 h-8 rounded-lg bg-gray-700 hover:bg-[#1E9B4C] flex items-center justify-center transition-colors" aria-label="WhatsApp">
                <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/></svg>
              </a>
              <a href="https://instagram.com/telnetindonesia" target="_blank" rel="noopener noreferrer" className="w-8 h-8 rounded-lg bg-gray-700 hover:bg-[#1E9B4C] flex items-center justify-center transition-colors" aria-label="Instagram">
                <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24"><path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/></svg>
              </a>
              <a href="https://youtube.com/@telnetindonesia" target="_blank" rel="noopener noreferrer" className="w-8 h-8 rounded-lg bg-gray-700 hover:bg-[#1E9B4C] flex items-center justify-center transition-colors" aria-label="YouTube">
                <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24"><path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/></svg>
              </a>
            </div>
          </div>

          <FooterColumn title="Layanan Utama" links={footerLinks.layanan} />
          <FooterColumn title="Infrastruktur" links={footerLinks.infrastruktur} />
          <FooterColumn title="IT Solutions" links={footerLinks.itSolutions} />
          <FooterColumn title="Informasi" links={footerLinks.legal} />
        </div>

        {/* Bottom */}
        <div className="border-t border-gray-700/50 mt-10 pt-6">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <div className="text-gray-500 text-xs">
              <p>&copy; 2025 PT Telekomunikasi Internet Indonesia. All rights reserved.</p>
              <div className="mt-1">
                <span>NIB: 1252000340416</span> · <span>APJII: 0926/APJII/K-2025</span>
              </div>
            </div>
            <button onClick={scrollToTop} className="mt-3 md:mt-0 text-gray-500 hover:text-white transition-colors text-xs flex items-center gap-1">
              ↑ Kembali ke Atas
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
